import styled from "styled-components";

export const ReportsWrapper = styled.div`
  .reports-header,
  .reports-filters,
  .reports-metrics,
  .reports-charts,
  .reports-summary,
  .reports-empty-state,
  .report-metric-card,
  .report-chart-card,
  .report-summary-card {
    background: #ffffff;
    border: 1px solid #dce5df;
    border-radius: 8px;
    box-shadow: 0 18px 42px rgba(32, 51, 46, 0.06);
  }

  .reports-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    padding: 1.25rem;
  }

  .reports-header h1 {
    margin: 0.3rem 0;
    color: #17342f;
    letter-spacing: 0;
    text-transform: none;
  }

  .reports-header p {
    margin: 0;
    color: #60716d;
  }

  .reports-back-btn {
    min-height: 42px;
    border: 1px solid #d5dfdc;
    border-radius: 8px;
    color: #49645e;
    font-weight: 900;
    text-decoration: none;
    padding: 0 1rem;
    display: inline-flex;
    align-items: center;
  }

  .reports-filters {
    margin-top: 1rem;
    padding: 1rem;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.9rem;
  }

  .lms-field {
    min-width: 0;
    display: grid;
    gap: 0.45rem;
    color: #263f3a;
    font-weight: 900;
  }

  .lms-field span {
    font-size: 0.92rem;
    line-height: 1.2;
  }

  .lms-field input,
  .lms-field select {
    width: 100%;
    min-height: 44px;
    border: 1px solid #d4dfdb;
    border-radius: 8px;
    background: #fbfdfc;
    color: #17342f;
    font: inherit;
    font-weight: 700;
    line-height: 1.2;
    padding: 0.65rem 0.8rem;
  }

  .reports-error,
  .reports-loading {
    margin: 1rem 0 0;
    font-weight: 800;
  }

  .reports-error {
    border-radius: 8px;
    background: #fff5f5;
    color: #9f2f2f;
    padding: 0.75rem 0.85rem;
  }

  .reports-loading {
    color: #60716d;
  }

  .reports-metrics {
    margin-top: 1rem;
    padding: 1rem;
    display: grid;
    gap: 0.75rem;
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .report-metric-card {
    padding: 0.8rem;
    box-shadow: none;
  }

  .report-metric-card p {
    margin: 0;
    color: #60716d;
    font-weight: 700;
  }

  .report-metric-card strong {
    display: block;
    margin-top: 0.45rem;
    color: #17342f;
    font-size: 1.15rem;
  }

  .reports-charts {
    margin-top: 1rem;
    padding: 1rem;
    display: grid;
    gap: 0.75rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .report-chart-card {
    padding: 0.85rem;
    box-shadow: none;
  }

  .report-chart-card header {
    display: flex;
    justify-content: space-between;
    gap: 0.6rem;
    align-items: center;
    margin-bottom: 0.65rem;
  }

  .report-chart-card h4 {
    margin: 0;
    color: #17342f;
    letter-spacing: 0;
    text-transform: none;
    font-size: 0.98rem;
  }

  .report-chart-card span {
    color: #49645e;
    font-weight: 800;
    font-size: 0.85rem;
  }

  .report-bar-track {
    height: 10px;
    border-radius: 999px;
    background: #e8f3ef;
    overflow: hidden;
  }

  .report-bar-fill {
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(90deg, #247467 0%, #3e8f80 100%);
  }

  .reports-summary {
    margin-top: 1rem;
    padding: 1rem;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
  }

  .report-summary-card {
    box-shadow: none;
    padding: 0.85rem;
  }

  .report-summary-card h4 {
    margin: 0 0 0.35rem;
    color: #17342f;
    text-transform: none;
    letter-spacing: 0;
    font-size: 0.96rem;
  }

  .report-summary-card p {
    margin: 0;
    color: #60716d;
    font-weight: 700;
  }

  .reports-empty-state {
    margin-top: 1rem;
    padding: 1.25rem;
  }

  .reports-empty-state h3 {
    margin: 0 0 0.45rem;
    color: #17342f;
    text-transform: none;
    letter-spacing: 0;
  }

  .reports-empty-state p {
    margin: 0;
    color: #60716d;
  }

  @media (max-width: 1040px) {
    .reports-metrics {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  @media (max-width: 760px) {
    .reports-header,
    .reports-filters,
    .reports-metrics,
    .reports-charts,
    .reports-summary {
      grid-template-columns: 1fr;
    }

    .reports-header {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;
